module.exports = __webpack_public_path__ + "img/ph_qrcode_wechat.49814b2.png";